"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = {
  GOAL_BUFFER_LENGTH: 30
};
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/videojs-contrib-hls/es5/config.js
// module id = 119
// module chunks = 1